export default __webpack_public_path__ + "static/media/search-icon.cc9b0aec.svg";